<template>
  <div>
    <div class="flex-container">
      <div class="table">
        <div class="title">管理组检查情况</div>
        <div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            style="
              margin-left: 15px;
              color: #fff;
              background-color: #1c84c6;
              border-color: #1c84c6;
            "
            :disabled="glzjcList.length >= 1"
            @click="handleChangeAddDialog"
            >意见反馈</el-button
          >
        </div>
        <el-table
          :max-height="height"
          :data="glzjcList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
        >
          <!-- v-if="scope.row.permissions.ischecklist" -->
          <el-table-column
            label="操作"
            align="left"
            min-width="250px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                @click="zqjcFormDialog = true"
                size="mini"
              >
                中期申请单
              </el-button>
              <el-button
                type="primary"
                size="mini"
                v-if="scope.row.permissions.isedit"
                @click="handleChangeEditDialog(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                type="danger"
                @click="delCheckItem(scope.row.feedbackId)"
                v-if="scope.row.permissions.isdel"
                size="mini"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="反馈人"
            align="left"
            prop="ygbh"
            min-width="80px"
            :show-overflow-tooltip="true"
          />

          <el-table-column
            label="反馈时间"
            align="left"
            prop="feedbackTime"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="意见反馈"
            align="left"
            prop="content"
            min-width="150px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="状态"
            align="left"
            prop="statusName"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="处理人"
            align="left"
            prop="solveBy"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="处理时间"
            align="left"
            prop="solveTime"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="检查人"
            align="left"
            prop="checkBy"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="检查时间"
            align="left"
            prop="checkTime"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <div class="table_count">共{{ glzjcList.length }}条记录</div>
      </div>
      <div class="result">
        <div class="title">专家委员会意见</div>
        <div>
          <div>
            <el-tabs v-model="zjwyhActive">
              <el-tab-pane
                :label="item.judges"
                :name="index + ''"
                v-for="(item, index) in zjwyhList"
                :key="index"
              >
                <div class="result_detail" v-html="item.advice1"></div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
      <div class="table">
        <div class="title">
          中期检查情况(课题研究进展情况：请根据立项申请表中的时间计划安排，说明任务完成情况)
        </div>

        <el-table
          :max-height="height"
          :data="zqjcList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
        >
          <el-table-column
            label="时间计划"
            align="left"
            prop="planTime"
            min-width="80px"
            :show-overflow-tooltip="true"
          />

          <el-table-column
            label="任务内容"
            align="left"
            prop="taskContent"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="进展情况"
            align="left"
            prop="progress"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="备注"
            align="left"
            prop="remark"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <pagination
          v-show="zqjcList.length > 0"
          :total="zqjcList.length"
          :page.sync="zqjcParams.page"
          :limit.sync="zqjcParams.pageSize"
          @pagination="getZqjcjdqk"
        />
      </div>
      <div class="card">
        <div class="steps">
          <div class="title">检查内容说明</div>
          <el-tabs v-model="jcnrsmActive">
            <el-tab-pane
              :label="item.version"
              :name="item.version"
              v-for="(item, index) in jcnrsmList"
              :key="index"
            >
              <div class="content">
                <div
                  class="content_item"
                  v-for="(item2, index2) in item.metaPropList"
                  :key="index2"
                >
                  <div class="content_title">{{ item2.cname }}</div>
                  <div class="content_text" v-html="item2.propValue"></div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div v-if="addAdviceDialog">
      <el-dialog
        title="意见反馈"
        :visible.sync="addAdviceDialog"
        append-to-body
        width="900px"
        :closeOnClickModal="false"
      >
        <div style="display: flex">
          <span style="width: 72px; text-align: right; margin-right: 15px"
            >状态<span style="color: #ff0000">*</span>:</span
          >
          <span>
            <el-radio-group v-model="addAdviceForm.status">
              <el-radio label="1">待修改</el-radio>
              <el-radio label="3">修改通过</el-radio>
            </el-radio-group></span
          >
        </div>
        <div style="line-height: 44px">
          意见反馈<span style="color: #ff0000">*</span> ：
        </div>
        <el-input
          type="textarea"
          v-model="addAdviceForm.content"
          :autosize="{ minRows: 6, maxRows: 12 }"
          maxlength="3000"
          show-word-limit
          placeholder="请输入意见反馈"
        />
        <span slot="footer" class="dialog-footer">
          <el-button @click="addAdviceDialog = false">取 消</el-button>
          <el-button type="primary" @click="addAdvice">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <el-dialog
      title="中期检查"
      :visible.sync="zqjcFormDialog"
      append-to-body
      width="90%"
      v-if="zqjcFormDialog"
      :closeOnClickModal="false"
    >
      <ZqjcForm
        :mxParams="this.mxParams"
        ref="zqjcForm"
        @getParentForm="getData"
      ></ZqjcForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="zqjcFormDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveZqjcForm">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { formatMomentDate } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import ZqjcForm from "../courseZqjcForm/zqjcForm.vue";
import Pagination from "@/components/Pagination";

import {
  getMidCheckResult,
  getInspection,
  deleteInspection,
  getCourseSituation,
  insertInspection,
  editInspection,
} from "@/api/course.js";
export default {
  name: "courseLxsq",
  computed: {},
  props: ["mxParams"],
  components: { ZqjcForm, Pagination },
  data() {
    return {
      addAdviceDialog: false,
      addAdviceForm: {
        status: "1",
        content: null,
      },
      feedbackId: null,
      zqjcFormDialog: false,
      jcnrsmList: [], //检查内容说明
      jcnrsmActive: null,
      glzjcList: [], //管理组检查表
      zqjcParams: {
        page: 1,
        pageSize: 10,
      },
      zqjcList: [], //中期检查情况
      zjwyhList: [], //专家委员会意见
      zjwyhActive: "0",
    };
  },

  created() {
    setTimeout(() => {
      if (!this.mxParams) {
        this.mxParams = this.$route.query;
      }
      this.getData();
    }, 100);
  },
  mounted() {},
  methods: {
    getData() {
      this.zqjcFormDialog = false;
      this.getZqjcnrData();
      this.getZqjcjdqk();
      this.getInspectionTable();
    },
    //删除管理组检查情况
    delCheckItem(feedbackId) {
      deleteInspection({ feedbackId }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.getInspectionTable();
        }
      });
    },
    //中期检查进度内容
    getZqjcnrData() {
      const courseId = this.mxParams.id;
      getMidCheckResult({ courseId }).then((res) => {
        if (res.code == 0) {
          if (
            res.data.midCheckAllVersion &&
            res.data.midCheckAllVersion.length > 0
          ) {
            this.jcnrsmList = res.data.midCheckAllVersion;
            this.jcnrsmActive = this.jcnrsmList[0].version;
          }
          // this.zjwyhActive = res.data.isCourseJudgese === 0 ? false : true;
          this.zjwyhList = res.data.expertOpinionInfos;
        }
      });
    },
    //中期检查进度情况
    getZqjcjdqk() {
      const { page, pageSize } = this.zqjcParams;
      const courseId = this.mxParams.id;
      getCourseSituation({ page, pageSize, courseId }).then((res) => {
        if (res.code == 0) {
          this.zqjcList = res.data;
        }
      });
    },
    // 管理组检查情况
    getInspectionTable() {
      const courseId = this.mxParams.id;

      getInspection({ courseId }).then((res) => {
        if (res.code == 0) {
          this.glzjcList = res.data.courseFeedbackInfo;
        }
      });
    },
    addAdvice() {
      if (!this.addAdviceForm.status) {
        this.$message.error("状态不能为空！");
        return;
      }
      if (!this.addAdviceForm.content) {
        this.$message.error("意见反馈不能为空！");
        return;
      }
      if (this.feedbackId) {
        editInspection({
          ...this.addAdviceForm,
          courseId: this.mxParams.id,
          feedbackId: this.feedbackId,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.addAdviceDialog = false;
            this.feedbackId = null;
            this.getInspectionTable();
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        insertInspection({
          ...this.addAdviceForm,
          courseId: this.mxParams.id,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.addAdviceDialog = false;
            this.getInspectionTable();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    handleChangeAddDialog() {
      this.addAdviceDialog = true;
      this.addAdviceForm = {
        status: "1",
        content: null,
      };
    },
    handleChangeEditDialog(row) {
      this.addAdviceForm = {
        status: row.status,
        content: row.content,
      };
      this.feedbackId = row.feedbackId;
      this.addAdviceDialog = true;
    },
    saveZqjcForm() {
      this.$refs.zqjcForm.saveForm();
    },
  },
};
</script>
<style lang="less" scoped>
.flex-container {
  width: 100%;
  height: 100%;
}
.tips {
  background-color: #d7d7d7;
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  margin: 15px 0;
}
.title {
  font-size: 15px;
  font-weight: bold;
  padding-left: 15px;
  line-height: 42px;
  height: 42px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 15px;
}
.table_count {
  color: #666;
  margin: 10px 15px;
}
.result {
  margin-bottom: 15px;
  .result_detail {
    font-size: 14px;
    background: #f3f3f3;
    line-height: 32px;
    padding-left: 15px;
    margin: 0 15px;
    color: #666;
  }
}

.content {
  margin-bottom: 30px;
  .content_item {
    line-height: 32px;
    font-size: 14px;
    margin-bottom: 15px;
    .content_title {
      font-weight: 700;
    }
    .content_text {
      background-color: #f3f3f3;
      padding: 5px 15px;
      margin-right: 15px;
    }
  }
}
</style>